import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Auth } from '@core/auth/services/auth';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const authSvc = inject(Auth)
  const user = authSvc.user()
  const token = user?.access_token;
  const authReq = token
    ? req.clone({
      setHeaders: { Authorization: `Bearer ${token}` }
    })
    : req;

  return next(authReq);
};
